document.addEventListener('DOMContentLoaded', function() {
  // Feature definitions - centralized configuration
  const FEATURES = {
    dimensions: { title: 'Dimensions', type: 'category' },
    width: { title: 'Width', type: 'dimension', metafield: 'width' },
    depth: { title: 'Depth', type: 'dimension', metafield: 'depth' },
    height: { title: 'Height', type: 'dimension', metafield: 'height' },
    desktop_height: { title: 'Desktop Height', type: 'dimension', metafield: 'desktop_height' },
    features: { title: 'Features', type: 'category' },
    keyboard_tray: {
      title: 'Adjustable Keyboard Tray',
      mobileTitle: 'Adjustable Keyboard Tray',
      description: 'Width x Depth x Height',
      type: 'keyboard_dimensions',
      metafield: 'keyboard_tray_dimensions'
    },
    heavy_duty_rail: {
      title: 'Heavy-duty Rail Compatibility',
      type: 'keyboard_check',
      metafield: 'keyboard_tray_dimensions'
    },
    sit_stand: { title: 'Sit-stand Workstation', type: 'boolean', metafield: 'is_motorized_leg' },
    // adjustable_desktop: {
    //   title: 'Adjustable Desktop Height',
    //   description: 'The desktop height can be adjusted at the feet to 74/76/78 cm',
    //   type: 'boolean',
    //   metafield: 'adjustable_desktop'
    // },
    split_desktop: { title: 'Split-level Desktop', type: 'boolean', metafield: 'split_desktop_compatible' },
    ssl_controller: { title: 'SSL Controller Slot', type: 'boolean', metafield: 'is_controller_slot' },
    cut_out: { title: 'Cut-out Desktop', type: 'boolean', metafield: 'is_cut_out' },
    speaker_shelf: { title: 'Speaker Shelf', type: 'boolean', metafield: 'is_speaker_shelf' },
    flat_shelves: { title: 'Flat Shelves', type: 'boolean', metafield: 'is_flat_shelf' },
    racks: { title: 'Racks', type: 'category' },
    rack_space: { title: 'Built-in Rack Space', type: 'text', metafield: 'rackunits' },
    rack_kit: {
      title: 'Rack Kit Compatibility',
      description: 'Expandable with an additional 2x10U',
      type: 'boolean',
      metafield: 'rackkit_compatible'
    },
    cover_panel: { title: 'Cover Panel Compatibility', type: 'boolean', metafield: 'coverpanel_compatible' },
    product_info: { title: 'Product Info', type: 'product_info' }
  };

  let allProducts = [];
  let maxProducts = 3;
  let isUpdating = false; // Flag to prevent multiple simultaneous updates

  // Debug logging function
  function debugLog(message, data = null) {
    if (window.location.hostname === 'localhost' || window.location.hostname.includes('myshopify.com')) {
      console.log(`[Comparison Table Debug] ${message}`, data || '');
    }
  }

  // Helper functions
  function getSvgContent(templateId) {
    const template = document.getElementById(templateId);
    return template ? template.innerHTML : '';
  }

  function isTrue(value) {
    if (value === null || value === undefined) return false;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
      const lowerValue = value.toLowerCase().trim();
      return lowerValue === 'true' || lowerValue === '1' || lowerValue === 'yes' || lowerValue === 'on';
    }
    if (typeof value === 'number') return value === 1;
    return false;
  }

  function normalizeBooleanMetafields(product) {
    if (product && product.metafields) {
      // Ensure all metafields exist, even if they're null/undefined
      const allMetafields = [
        'width', 'depth', 'height', 'desktop_height', 'keyboard_tray_dimensions',
        'adjustable_desktop', 'split_desktop_compatible', 'rackkit_compatible', 
        'coverpanel_compatible', 'is_motorized_leg', 'is_controller_slot', 
        'is_cut_out', 'is_speaker_shelf', 'is_flat_shelf', 'rackunits'
      ];
      
      allMetafields.forEach(field => {
        if (product.metafields[field] === undefined) {
          product.metafields[field] = null;
          debugLog(`Set missing metafield ${field} to null for product ${product.title}`);
        }
      });
    } else if (product) {
      // Initialize metafields object if it doesn't exist
      product.metafields = {};
      debugLog(`Initialized empty metafields object for product ${product.title}`);
    }
    return product;
  }

  function parseKeyboardDimensions(dimensionsString) {
    if (!dimensionsString) return null;
    
    let dimensions;
    if (typeof dimensionsString === 'string' && dimensionsString.startsWith('[')) {
      try {
        dimensions = JSON.parse(dimensionsString);
      } catch (e) {
        dimensions = dimensionsString.split(',').map(d => d.trim());
      }
    } else {
      dimensions = dimensionsString.split(',').map(d => d.trim());
    }
    
    return dimensions.map(d => (d || '(X)').replace(/["\[\]]/g, '').trim());
  }

  // Initialize product data with enhanced error handling
  function initializeProductData() {
    debugLog('Initializing product data...');
    
    if (!window.productData) {
      debugLog('ERROR: window.productData is not defined');
      return false;
    }

    debugLog('Product data found:', window.productData);

    // Check if current product exists and has required fields
    if (window.productData.current) {
      const currentProduct = window.productData.current;
      debugLog('Current product:', currentProduct);
      
      // Validate current product has minimum required data
      if (!currentProduct.id || !currentProduct.title) {
        debugLog('ERROR: Current product missing required fields (id or title)');
        return false;
      }
      
      allProducts.push(normalizeBooleanMetafields(currentProduct));
      debugLog('Current product added to allProducts');
    } else {
      debugLog('ERROR: No current product found in productData');
      return false;
    }
    
    // Add compare products if they exist
    if (window.productData.compare && window.productData.compare.length > 0) {
      debugLog(`Found ${window.productData.compare.length} compare products`);
      window.productData.compare.forEach((metafieldProduct, index) => {
        debugLog(`Processing compare product ${index + 1}:`, metafieldProduct);
        
        if (metafieldProduct && metafieldProduct.id && metafieldProduct.title) {
          const exists = allProducts.find(p => p.id === metafieldProduct.id);
          if (!exists) {
            allProducts.push(normalizeBooleanMetafields(metafieldProduct));
            debugLog(`Compare product ${index + 1} added to allProducts`);
          } else {
            debugLog(`Compare product ${index + 1} already exists, skipping`);
          }
        } else {
          debugLog(`ERROR: Compare product ${index + 1} missing required fields`);
        }
      });
    } else {
      debugLog('No compare products found');
    }

    debugLog(`Total products loaded: ${allProducts.length}`);
    return allProducts.length > 0;
  }

  function getMaxProducts() {
    if (window.innerWidth <= 749) return 2;
    if (window.innerWidth <= 988) return 2;
    return 3;
  }

  function updateGridLayout() {
    const gridTemplate = `1fr ${'1fr '.repeat(maxProducts)}`;
    
    // Cache selectors to avoid repeated DOM queries
    const headerRow = document.querySelector('.comparison-table__header-row');
    const specRows = document.querySelectorAll('.comparison-table__spec-row');
    
    // Only update if the grid template would actually change
    if (headerRow && headerRow.style.gridTemplateColumns !== gridTemplate) {
      headerRow.style.gridTemplateColumns = gridTemplate;
    }
    
    specRows.forEach(row => {
      if (row.style.gridTemplateColumns !== gridTemplate) {
        row.style.gridTemplateColumns = gridTemplate;
      }
    });
  }

  // Generate feature value based on type
  function generateFeatureValue(product, feature) {
    const metafields = product.metafields || {};
    
    switch (feature.type) {
      case 'dimension':
        const dimensionData = metafields[feature.metafield];
        if (dimensionData && dimensionData.value && dimensionData.value.trim() !== '') {
          debugLog(`Displaying dimension ${feature.metafield}: ${dimensionData.value}${dimensionData.unit || ''} for ${product.title}`);
          return `<p>${dimensionData.value}${dimensionData.unit || ''}</p>`;
        }
        debugLog(`Missing dimension ${feature.metafield} for ${product.title}, showing (X) icon`);
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'keyboard_dimensions':
        const dimensions = parseKeyboardDimensions(metafields.keyboard_tray_dimensions);
        if (dimensions && dimensions.every(d => d && d !== '(X)' && d.trim() !== '')) {
          debugLog(`Displaying keyboard dimensions: ${dimensions[0]} x ${dimensions[1]} x ${dimensions[2]} cm for ${product.title}`);
          return `<p>${dimensions[0]} x ${dimensions[1]} x ${dimensions[2]} cm</p>`;
        }
        debugLog(`Missing keyboard dimensions for ${product.title}, showing (X) icon`);
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'keyboard_check':
        const checkDimensions = parseKeyboardDimensions(metafields.keyboard_tray_dimensions);
        if (checkDimensions && checkDimensions.every(d => d && d !== '(X)' && d.trim() !== '')) {
          debugLog(`Keyboard check passed for ${product.title}, showing checkmark`);
          return `<div class="comparison-table__available">${getSvgContent('svg-available')}</div>`;
        }
        debugLog(`Keyboard check failed for ${product.title}, showing (X) icon`);
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'boolean':
        const booleanValue = metafields[feature.metafield];
        if (booleanValue !== null && booleanValue !== undefined && isTrue(booleanValue)) {
          debugLog(`Boolean ${feature.metafield} is true for ${product.title}, showing checkmark`);
          return `<div class="comparison-table__available">${getSvgContent('svg-available')}</div>`;
        }
        debugLog(`Boolean ${feature.metafield} is false/null for ${product.title}, showing (X) icon`);
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'text':
        const textValue = metafields[feature.metafield];
        if (textValue && textValue.toString().trim() !== '') {
          debugLog(`Displaying text ${feature.metafield}: ${textValue} for ${product.title}`);
          return `<p>${textValue}</p>`;
        }
        debugLog(`Missing text ${feature.metafield} for ${product.title}, showing (X) icon`);
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;

      case 'product_info':
        debugLog(`Displaying product info for ${product.title}`);
        return `<div class="comparison-table__product-info-display" data-product-id="${product.id}">
          <div class="comparison-table__product-name">${product.title}</div>
          ${product.price ? `<div class="price__container">
            ${product.price}
          </div>` : ''}
          ${product.url ? `<div class="comparison-table__view-details-wrapper">
            <a href="${product.url}" class="comparison-table__view-details-button">
              <span>View Details</span>
            </a>
          </div>` : ''}
        </div>`;

      default:
        debugLog(`Unknown feature type ${feature.type} for ${product.title}, showing (X) icon`);
        return `<div class="comparison-table__unavailable">${getSvgContent('svg-unavailable')}</div>`;
    }
  }

  function generateProductHeader(product) {
    return `
      <div class="comparison-table__header-cell">
        <div class="comparison-table__product-card" data-product-id="${product.id}">
          <div class="comparison-table__image-wrapper">
            ${product.image ? 
              `<img src="${product.image}" alt="${product.title}" class="comparison-table__image">` : 
              `<div class="comparison-table__no-image">No Image</div>`}
          </div>
          <div class="comparison-table__product-info">
            <h3 class="comparison-table__product-title">${product.title}</h3>
            ${product.url ? `<div class="comparison-table__view-details-wrapper">
              <a href="${product.url}" class="comparison-table__view-details-button">
                <span>View Details</span>
              </a>
            </div>` : ''}
          </div>
          <div class="comparison-table__change-button">
            <span>Change</span>
          </div>
        </div>
      </div>
    `;
  }

  function generateFeatureRow(featureKey, feature) {
    const visibleProducts = allProducts.slice(0, maxProducts);
    
    if (feature.type === 'category') {
      return `
        <div class="comparison-table__spec-row comparison-table__spec-row--category">
          <div class="comparison-table__spec-cell--category">
            <span class="comparison-table__spec-cell--title">${feature.title}</span>
          </div>
          ${visibleProducts.map(() => '<div class="comparison-table__spec-cell"></div>').join('')}
        </div>
      `;
    }

    if (feature.type === 'product_info') {
      return `
        <div class="comparison-table__spec-row comparison-table__spec-row--product-info">
          <div class="comparison-table__spec-cell--category">&nbsp;</div>
          ${visibleProducts.map(product => `
            <div class="comparison-table__spec-cell">
              ${generateFeatureValue(product, feature)}
            </div>
          `).join('')}
        </div>
      `;
    }

    const mobileTitle = feature.mobileTitle || feature.title;
    const mobileDescription = feature.description ? `<div class="comparison-table__mobile-feature-description">${feature.description}</div>` : '';

    return `
      <div class="comparison-table__spec-row">
        <div class="comparison-table__spec-cell--category">
          <span class="comparison-table__feature">${feature.title}</span>
          ${feature.description ? `<h4 class="comparison-table__feature-description">${feature.description}</h4>` : ''}
        </div>
        ${visibleProducts.map(product => `
          <div class="comparison-table__spec-cell">
            <div class="comparison-table__mobile-feature-label">${mobileTitle}</div>
            ${mobileDescription}
            ${generateFeatureValue(product, feature)}
          </div>
        `).join('')}
      </div>
    `;
  }

  // Check if all visible products have unavailable features
  function isFeatureUnavailableForAll(featureName) {
    const visibleProducts = allProducts.slice(0, maxProducts);
    
    const featureChecks = {
      'Width': (product) => !!(product.metafields?.width?.value && product.metafields.width.value.trim() !== ''),
      'Depth': (product) => !!(product.metafields?.depth?.value && product.metafields.depth.value.trim() !== ''),
      'Height': (product) => !!(product.metafields?.height?.value && product.metafields.height.value.trim() !== ''),
      'Desktop Height': (product) => !!(product.metafields?.desktop_height?.value && product.metafields.desktop_height.value.trim() !== ''),
      'Adjustable Keyboard Tray': (product) => {
        const dimensions = parseKeyboardDimensions(product.metafields?.keyboard_tray_dimensions);
        return !!(dimensions && dimensions.every(d => d && d !== '(X)' && d.trim() !== ''));
      },
      'Adjustable Desktop Height': (product) => {
        const value = product.metafields?.adjustable_desktop;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Split-level Desktop': (product) => {
        const value = product.metafields?.split_desktop_compatible;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Sit-stand Workstation': (product) => {
        const value = product.metafields?.is_motorized_leg;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Built-in Rack Space': (product) => {
        const value = product.metafields?.rackunits;
        return !!(value && value.toString().trim() !== '');
      },
      'Rack Kit Compatibility': (product) => {
        const value = product.metafields?.rackkit_compatible;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Cover Panel Compatibility': (product) => {
        const value = product.metafields?.coverpanel_compatible;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'SSL Controller Slot': (product) => {
        const value = product.metafields?.is_controller_slot;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Cut-out Desktop': (product) => {
        const value = product.metafields?.is_cut_out;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Speaker Shelf': (product) => {
        const value = product.metafields?.is_speaker_shelf;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Flat Shelves': (product) => {
        const value = product.metafields?.is_flat_shelf;
        return !!(value !== null && value !== undefined && isTrue(value));
      },
      'Heavy-duty Rail Compatibility': (product) => {
        const dimensions = parseKeyboardDimensions(product.metafields?.keyboard_tray_dimensions);
        return !!(dimensions && dimensions.every(d => d && d !== '(X)' && d.trim() !== ''));
      }
    };

    const checkFunction = featureChecks[featureName];
    if (!checkFunction) return true;

    return visibleProducts.every(product => !checkFunction(product));
  }

  function hideUnavailableRows() {
    const specRows = document.querySelectorAll('.comparison-table__spec-row:not(.comparison-table__spec-row--category)');
    
    specRows.forEach(row => {
      const featureElement = row.querySelector('.comparison-table__feature');
      if (!featureElement) return;
      
      const featureName = featureElement.textContent.trim();
      
      // Never hide the "Built-in Rack Space" feature
      if (featureName === 'Built-in Rack Space') {
        row.classList.remove('comparison-table__row--hidden');
        return;
      }
      
      const shouldHide = isFeatureUnavailableForAll(featureName);
      row.classList.toggle('comparison-table__row--hidden', shouldHide);
    });
  }

  function generateTable() {
    debugLog('Generating table...');
    debugLog(`allProducts length: ${allProducts.length}`);
    
    if (allProducts.length === 0) {
      debugLog('ERROR: No products to display');
      return;
    }
    
    maxProducts = getMaxProducts();
    const visibleProducts = allProducts.slice(0, maxProducts);
    debugLog(`Visible products: ${visibleProducts.length}`);

    // Generate product headers
    const headersContainer = document.getElementById('comparison-table__product-headers');
    if (headersContainer) {
      debugLog('Generating product headers...');
      headersContainer.innerHTML = visibleProducts.map(product => generateProductHeader(product)).join('');
    } else {
      debugLog('ERROR: Headers container not found');
    }

    // Generate specifications
    const specsContainer = document.getElementById('comparison-table__specs');
    if (specsContainer) {
      debugLog('Generating specifications...');
      specsContainer.innerHTML = Object.entries(FEATURES).map(([key, feature]) => generateFeatureRow(key, feature)).join('');
    } else {
      debugLog('ERROR: Specs container not found');
    }

    updateGridLayout();
    hideUnavailableRows();

    // Add event listeners to product cards
    const productCards = document.querySelectorAll('.comparison-table__product-card');
    debugLog(`Found ${productCards.length} product cards`);
    
    productCards.forEach(card => {
      card.addEventListener('click', (e) => {
        // Don't open modal if clicking on view details button
        if (e.target.closest('.comparison-table__view-details-button')) {
          return;
        }
        showProductSelector(card);
      });
      
      // Handle view details button hover to hide change button
      const viewDetailsButton = card.querySelector('.comparison-table__view-details-button');
      if (viewDetailsButton) {
        viewDetailsButton.addEventListener('mouseenter', () => {
          card.classList.add('view-details-hover');
        });
        viewDetailsButton.addEventListener('mouseleave', () => {
          card.classList.remove('view-details-hover');
        });
      }
    });

    // Safari-specific optimizations
    optimizeForSafari();
    
    debugLog('Table generation complete');
  }

  function optimizeForSafari() {
    // Force hardware acceleration for Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (isSafari) {
      // Apply hardware acceleration to images
      document.querySelectorAll('.comparison-table__image').forEach(element => {
        element.style.transform = 'translateZ(0)';
        element.style.webkitTransform = 'translateZ(0)';
        element.style.willChange = 'auto';
      });
      
      // Prevent layout shifts during scroll
      document.querySelectorAll('.comparison-table__product-card, .comparison-table__image-wrapper').forEach(element => {
        element.style.transform = 'translateZ(0)';
        element.style.webkitTransform = 'translateZ(0)';
        element.style.backfaceVisibility = 'hidden';
        element.style.webkitBackfaceVisibility = 'hidden';
      });
    }
  }

  function showProductSelector(card) {
    const cardIndex = Array.from(document.querySelectorAll('.comparison-table__product-card')).indexOf(card);
    const visibleProductIds = allProducts.slice(0, maxProducts).map(p => p.id);
    const selectableProducts = allProducts.filter(product => !visibleProductIds.includes(product.id));
    
    if (selectableProducts.length === 0) return;

    const modal = document.createElement('div');
    modal.className = 'comparison-table__modal';
    modal.innerHTML = `
      <div class="comparison-table__modal-content">
        <div class="comparison-table__modal-header">
          <h3>Select a Product</h3>
          <button class="comparison-table__modal-close">&times;</button>
        </div>
        <div class="comparison-table__modal-body">
          <div class="comparison-table__product-grid">
            ${selectableProducts.map(product => `
              <div class="comparison-table__modal-product" data-product-id="${product.id}">
                <div class="comparison-table__modal-product-image">
                  ${product.image ? 
                    `<img src="${product.image}" alt="${product.title}">` : 
                    `<div class="comparison-table__no-image">Product</div>`}
                </div>
                <div class="comparison-table__modal-product-info">
                  <h3>${product.title}</h3>
                </div>
                <div class="comparison-table__modal-select-button">
                  <span>Select</span>
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // Event handlers
    modal.querySelector('.comparison-table__modal-close').addEventListener('click', () => modal.remove());
    modal.addEventListener('click', (e) => e.target === modal && modal.remove());
    
    modal.querySelectorAll('.comparison-table__modal-product').forEach(productElement => {
      productElement.addEventListener('click', () => {
        const newProductId = productElement.dataset.productId;
        const newProduct = allProducts.find(p => p.id === newProductId);
        if (newProduct) {
          allProducts[cardIndex] = newProduct;
          generateTable();
        }
        modal.remove();
      });
    });
  }

  function addMobileHandlers() {
    const mobileButtons = [
      '.comparison-table__compare-more-link-button',
      '.comparison-table__compare-more-full-button'
    ];
    
    mobileButtons.forEach(selector => {
      const button = document.querySelector(selector);
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const firstProductCard = document.querySelector('.comparison-table__product-card');
          if (firstProductCard) showProductSelector(firstProductCard);
        });
      }
    });
  }

  // Initialize with error handling
  debugLog('Comparison table script loaded');
  
  const initializationSuccess = initializeProductData();
  
  if (!initializationSuccess) {
    debugLog('ERROR: Failed to initialize product data. Table will not be generated.');
    // Show a fallback message or hide the table container
    const container = document.querySelector('.comparison-table__container');
    if (container) {
      container.innerHTML = '<div style="text-align: center; padding: 2rem; color: #666;">Comparison data not available for this product.</div>';
    }
    return;
  }
  
  setTimeout(() => {
    generateTable();
    addMobileHandlers();
  }, 100);

  // Handle resize with debouncing to prevent flashing
  let resizeTimeout;
  let lastMaxProducts = maxProducts;
  
  window.addEventListener('resize', () => {
    if (isUpdating) return; // Prevent multiple simultaneous updates
    
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newMaxProducts = getMaxProducts();
      
      // Only regenerate if the number of visible products actually changes
      if (newMaxProducts !== lastMaxProducts) {
        debugLog(`Max products changed from ${lastMaxProducts} to ${newMaxProducts}, regenerating table`);
        lastMaxProducts = newMaxProducts;
        isUpdating = true;
        generateTable();
        isUpdating = false;
      } else {
        // Just update the grid layout without regenerating content
        debugLog('Max products unchanged, only updating grid layout');
        updateGridLayout();
      }
    }, 150); // 150ms debounce delay
  });
}); 